import { ValidReferenceFileType } from '@/modules/referenceImage/types';
import { VALID_REFERENCE_FILE_TYPES } from './constants';

export function isValidReferenceFileType(type: string): type is ValidReferenceFileType {
  return (VALID_REFERENCE_FILE_TYPES as readonly string[]).includes(type);
}
